export default "__VITE_ASSET__ace711ad__"